<template>
  <div class="assinatura-mensal">
    <!-- <div class="notification-bar">
      <div class="notification-bar-1"></div>
    </div> -->
    <div class="assinatura-mensal-1">Assinatura {{
        planSelected.modeloCobranca.recorrenciaPeriodicidadeTipo === 'ANUAL'
          ? 'anual'
          : 'mensal'
      }}</div>
    <div class="kits-montados-por-sommelier" v-if="APP_ORIGEN === 'BEBOH'">Kits montados por sommelier</div>
    <div class="assinatura-1">
      <div v-for="(item, index) of this.objSignature" :key="index" class="plano-mensal"
        :class="{ 'selected-plan': activePlan === item.id }" @click="setActivePlan(item.id)">
        <span class="plano-text" :class="{ 'selected-plan-text': activePlan === item.id }"> {{
        separarPartes(item.nome)[0] }} <br> {{ separarPartes(item.nome)[1] }} </span>
      </div>
    </div>
    <div class="price">
      <span class="ms">{{ formatPrice(planSelected.modeloCobranca.valorTotal) }}/{{
        planSelected.modeloCobranca.recorrenciaPeriodicidadeTipo === 'ANUAL'
          ? 'ano'
          : 'mês'
      }}</span>
      <!-- <div class="bebidas-artesanais">2 bebidas artesanais</div> -->
    </div>
    <div class="d-flex justify-content-center align-items-center assinatura-imagem">
      <img :src="planSelected.urlImagemPromocional" alt="" class="responsive-image" width="50%">
    </div>
    <div class="group-351">
      <div class="rectangle-121">
      </div>

      <div class="kit-do-ms" v-if="APP_ORIGEN === 'BEBOH'">Kit do Mês</div>
      <div class="descrio">
        <div class="sobre-okit" v-if="APP_ORIGEN === 'BEBOH'">Sobre o kit</div>
        <div class="sobre-okit">Sobre</div>
        <span v-html="planSelected.descricao" class="descricao">
        </span>
      </div>
      <div class="descrio">
        <div class="sobre-okit" v-if="APP_ORIGEN === 'BEBOH'">Regras do plano</div>
        <span v-html="planSelected.regulamento" class="descricao">
        </span>
      </div>
      <div class="mt-3 mb-2 px-3 col justify-content-between">
        <button class="btn btn_color_system py-2 px-5 mt-4" type="button" @click="assinar(planSelected.id)">
          CONTINUAR
        </button>
      </div>

    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
// import { APIService } from '../APIService'
// const apiService = new APIService()
export default {
  name: 'AssinaturaMensal',
  props: {
    objSignature: Array,
    signatureModal: Boolean,
    selectedPlan: Object
  },
  components: { Loading },
  data() {
    return {
      activePlan: 'basico',
      objDetalhes: { idProduto: 0, quantidade: 0, objProduto: {} },
      controleEstoque: window.CONTROLE_ESTOQUE,
      loading: false,
      planSelected: null,
      APP_ORIGEN: window.APP_ORIGEN,
    };
  },
  created() {
    this.objSignature = this.objSignature.sort((a, b) => a.id - b.id);
    this.activePlan = this.objSignature[0].id;
    this.planSelected = this.objSignature[0];
  },
  computed: {
    toogleMicroApp() {
      return this.$store.state.toogleMicroApp;
    },
  },
  watch: {
    selectedPlan: {
      immediate: true,
      handler(newPlan) {
        this.updatePlanSelected(newPlan);
      }
    }
  },
  methods: {
    updatePlanSelected(newPlan) {
      this.planSelected = newPlan;
      this.setActivePlan( this.planSelected.id);
    },
    setActivePlan(id) {
      this.activePlan = id;
      this.planSelected = this.objSignature.filter(obj => obj.id == id)[0];
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return `R$${'\xa0'}${val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
    },
    separarPartes(nomePlano) {
      if (!nomePlano) {
        return ['', ''];
      }
      const partes = nomePlano.split(' ');
      const plano = partes[0] ? partes[0].trim() : '';
      const nome = partes[1] ? partes[1].trim() : '';
      return [plano, nome];
    },
    assinar(id) {
      this.$router.push(`/planos/simulador/${id}`)
    }
  }
};
</script>

<style scoped>
@media (max-width: 770px) {}

.assinatura-mensal {
  background: var(--bg, #FFFFFF);
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
  box-sizing: border-box;
}

.assinatura-mensal .assinatura-mensal-1 {
  margin: 0 16px 3px 16px;
  display: inline-block;
  align-self: flex-start;
  overflow-wrap: break-word;
  font-family: 'Abel';
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}

.assinatura-imagem {
  margin: 10px;
  max-width: 100%;
  height: auto;
}

.responsive-image {
  max-width: 100%;
  max-height: 100%;
}

.assinatura-mensal .kits-montados-por-sommelier {
  margin: 0 16px 21px 16px;
  display: inline-block;
  align-self: flex-start;
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-body-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-body-font-weight, 400);
  font-size: var(--mobilesecondary-text-body-font-size, 16px);
  color: #000000;
}

.assinatura-mensal .price {
  margin: 0 16px 14px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: flex-start;
  width: 353.1px;
  box-sizing: border-box;
}

.assinatura-mensal .ms {
  margin-right: 12.5px;
  width: 213.5px;
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-heading-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-heading-font-weight, 700);
  font-size: var(--mobilesecondary-text-heading-font-size, 20.8px);
  color: #000000;
}

.assinatura-mensal .bebidas-artesanais {
  margin-top: 5px;
  display: inline-block;
  overflow-wrap: break-word;
  font-family: 'Abel';
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.assinatura-mensal .group-351 {
  margin: 0 16px 97px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: calc(100% - 32px);
  box-sizing: border-box;
}

.assinatura-mensal .kit-do-ms {
  margin: 0 1.2px 12px 1.2px;
  display: inline-block;
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-heading-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-heading-font-weight, 700);
  font-size: var(--mobilesecondary-text-heading-font-size, 20.8px);
  color: #000000;
}

.assinatura-mensal .descrio {
  margin-right: 16.4px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 16.4px);
  box-sizing: border-box;
}

.assinatura-mensal .sobre-okit {
  margin-bottom: 5px;
  display: inline-block;
  align-self: flex-start;
  overflow-wrap: break-word;
  font-family: 'Abel';
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}

.assinatura-mensal {
  font-family: var(--mobilesecondary-text-body-font-family, 'Lato');
}

.assinatura-mensal .descricao {
  text-align: justify;
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-body-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-body-font-weight, 400);
  font-size: var(--mobilesecondary-text-body-font-size, 16px);
  color: #A7A7A7;
}

.assinatura-mensal .assinatura-1 {
  border-radius: 10px;
  background: #F1F1F1;
  position: relative;
  margin: 10px;
  display: flex;
  flex-direction: row;
  padding: 5px;
  box-sizing: border-box;
  gap: 10px;
}

.assinatura-mensal .notification-bar {
  display: flex;
  width: 100%;
  min-height: 59px;
  box-sizing: border-box;
}

.assinatura-mensal .plano-mensal {
  border-radius: 10px;
  margin: 0;
  display: flex;
  flex-grow: 1;
  box-sizing: border-box;
  height: 70px;
  align-items: center;
  justify-content: center;
}

.assinatura-mensal .plano-text {
  text-align: center;
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-body-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-body-font-weight, 400);
  font-size: var(--mobilesecondary-text-body-font-size, 16px);
  color: var(--gray-subtitle, #A8A8A8);
}

.assinatura-mensal .selected-plan {
  border-radius: 10px;
  background: #FFFFFF;
  display: flex;
  padding: 21px 19.1px;
  flex-grow: 1;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}

.assinatura-mensal .selected-plan-text {
  overflow-wrap: break-word;
  font-family: var(--mobilesecondary-text-body-font-family, 'Lato');
  font-weight: var(--mobilesecondary-text-body-font-weight, 400);
  font-size: var(--mobilesecondary-text-body-font-size, 16px);
  color: #D54510;
}

.assinatura-mensal .notification-bar-1 {
  background: #FFFFFF;
  width: 430px;
  height: 59px;
}

.assinatura-mensal .camada-1 {
  width: 50px;
  height: 54.5px;
}
</style>
